// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"2f316724","537":"c9123faa","636":"5d0b8766","988":"773c3e14"}[chunkId] + ".chunk.css";
};